import React, { useContext, useRef } from 'react'

import { WappContext, withWapp } from 'wapplr-react/dist/common/Wapp'

import Button from 'karrierhub-ui/dist/common/src/components/Button'
import Typography from 'karrierhub-ui/dist/common/src/components/Typography'
import FacebookIcon from 'karrierhub-ui/dist/common/src/svg/FacebookIcon'
import GoogleIcon from 'karrierhub-ui/dist/common/src/svg/GoogleIcon'
import ButtonContext from 'karrierhub-ui/dist/common/src/components/Button/context'

import AppContext from '../../App/context'

import style from './style.css'

function Social() {

    const buttonContext = useContext(ButtonContext)

    const context = useContext(WappContext)
    const appContext = useContext(AppContext)

    const { wapp } = context

    wapp.styles.use(style)
    const disabled = useRef(false)

    return (
        <div className={style.social}>
            <Typography Component={'div'} variant={'subtitle1'} className={style.socialTitle}>
                {appContext.titles.socialLoginTitle}
            </Typography>
            <div className={style.socialButtons}>
                <ButtonContext.Provider value={{ ...buttonContext, onClick: null }}>
                    <Button
                        className={style.facebookButton}
                        color={'success'}
                        href={'/auth/facebook'}
                        onClick={(e) => {
                            if (!disabled.current) {
                                disabled.current = true
                            } else {
                                e.preventDefault()
                            }
                        }}
                        size={'default'}
                        label={'Facebook'}
                        fullWidth={true}
                        startIcon={<FacebookIcon />}
                        noreferrer={undefined}
                    />
                    <Button
                        color={'secondary'}
                        href={'/auth/google'}
                        onClick={(e) => {
                            if (!disabled.current) {
                                disabled.current = true
                            } else {
                                e.preventDefault()
                            }
                        }}
                        size={'default'}
                        label={'Google'}
                        fullWidth={true}
                        startIcon={<GoogleIcon />}
                        noreferrer={undefined}
                    />
                </ButtonContext.Provider>
            </div>
        </div>
    )
}

export default withWapp(Social)
